import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

interface ValidatorOptions {
  field1: string;
  field2: string;
}

export function fieldValuesMustMatch(options: ValidatorOptions): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!control || !control.root || !control.parent) {
      return null;
    }

    const field1Value = control.root.get(options.field1).value;
    const field2Value = control.root.get(options.field2).value;

    if (field1Value !== field2Value) {
      return { fieldValueMismatch: true };
    }

    return null;
  };
}
